import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import Svg, { Path } from 'react-native-svg';
function SvgComponent(props) {
  var color = props.color;
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement(Path, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.983 11.26a4.267 4.267 0 116.034 0 .4.4 0 00.566.565 5.067 5.067 0 10-7.166 0 .4.4 0 00.566-.566zM5.802 12.928c0-.22.179-.4.4-.4h3.63a.4.4 0 110 .8h-3.63a.4.4 0 01-.4-.4zM6.255 14.578c0-.22.18-.4.4-.4h2.723a.4.4 0 010 .8H6.655a.4.4 0 01-.4-.4zM8.017.758c.22 0 .4.179.4.4v.907a.4.4 0 01-.8 0v-.907c0-.221.179-.4.4-.4zM3.042 2.646a.4.4 0 01.566 0l.642.642a.4.4 0 11-.566.566l-.642-.642a.4.4 0 010-.566zM13.013 2.646a.4.4 0 00-.566 0l-.642.642a.4.4 0 00.566.566l.642-.642a.4.4 0 000-.566z",
    fill: color !== null && color !== void 0 ? color : '#000',
    fillOpacity: 0.87
  }), /*#__PURE__*/React.createElement(Path, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.064 7.674a.015.015 0 00-.02 0L7.555 9.162a.815.815 0 01-1.153 0l-.743-.744a.4.4 0 11.565-.566l.744.744a.015.015 0 00.021 0l1.488-1.488a.815.815 0 011.152 0l.744.744a.4.4 0 11-.566.566l-.744-.744z",
    fill: color !== null && color !== void 0 ? color : '#000',
    fillOpacity: 0.87
  }));
}
export default SvgComponent;